import { DealerChannel } from "@/enums";

export const dealerChannelsOptions = Object.entries(DealerChannel).map(
  ([label]) => label
);
